import { Component } from '@angular/core';
import { DataSource } from '@angular/cdk';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { MailData } from '../../classes/mail-data.class';
import { HttpService } from '../../services/http.service';
import { MdDialog } from '@angular/material';
import { DialogShowInfoComponent } from '../dialogs/dialog-show-info.component';
import { DialogAddHostComponent } from '../dialogs/dialog-add-host.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-mail',
  templateUrl: '../../templates/mail/mail.component.html'
})
export class MailComponent {

  leaveType = [{ code: "1", name: "Funeral"},{ code: "2", name: "Sick Leave"},{ code: "3", name: "Vacation Leave"}];

  color = 'primary';
  mode = 'determinate';

  // Data vir ons table
  MailData = new MailData();
  displayedColumns = ['domain', 'sendtoaddr', 'hash', 'secretkey'];
  public mailDatabase;
  dataSource: MailDataSource | null;

  constructor(private httpService:HttpService,public dialog: MdDialog){
    this.mailDatabase = new MailDatabase(httpService,dialog);// Ons maak n nuwe database vir ons table
  }

  ngOnInit() {
    this.dataSource = new MailDataSource(this.mailDatabase);// Ons maak 'n nuwe data source vir ons table
  }

  addHostDialog(){
    this.dialog.open(DialogAddHostComponent, {});
  }

  showHash(hash:string) {
    this.dialog.open(DialogShowInfoComponent, {
       data: hash
    });
  }

  showKey(secretkey:string) {
    this.dialog.open(DialogShowInfoComponent, {
       data: secretkey
    });
  }
}

// Hier luister ons op die "child_added" event op die realtime database en
// as 'n child bykom dan word dit gestoor in ons Subject. Dit emit dadelik 
// 'n view change as sy data verander.

export class MailDatabase {
  dataChange: BehaviorSubject<MailData[]> = new BehaviorSubject<MailData[]>([]);
  get data(): MailData[] { return this.dataChange.value; }

  constructor(httpService:HttpService,public dialog: MdDialog) {

      let hosts: MailData[] = [];

      httpService.listHosts().subscribe(
      //3 callbacks (data,err,done)
      (data: any) => {
        if (data && data !== "") {
          hosts = data;
          if(hosts.length > 0)
          {
            hosts.forEach(host => {
            const copiedData = this.data.slice();
            copiedData.push(host);
            this.dataChange.next(copiedData);//elke leave entry
            });
          } 
        }
      }, (err: any) => {
        this.dialog.open(DialogShowInfoComponent, {
              data: 'Too many requests. Try again in 5 minutes.'
            });
      });
  }
}

export class MailDataSource extends DataSource<any> {
  constructor(private _mailDatabase: MailDatabase) {
    super();
  }

  connect(): Observable<MailData[]> {
    return this._mailDatabase.dataChange;
  }

  disconnect() {}
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/mail/mail.component.ts